// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e4bdaebb","453":"f2f95d31","732":"a4243057","977":"b1b42397"}[chunkId] + ".chunk.js";
};